'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _glamor = require('glamor');

var _components = require('components');

var _Section = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/Section');

var _Section2 = _interopRequireDefault(_Section);

var _TextButton = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton');

var _TextButton2 = _interopRequireDefault(_TextButton);

var _Hero = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero');

var _Hero2 = _interopRequireDefault(_Hero);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _fonts = require('@quixeltools/quixel-ui-library/dist/utils/fonts');

var _cloudFront = require('../../utils/cloudFront');

var cloudFrontUtils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cf = function cf(path) {
  return __CLIENT__ && 'https://d3uwib8iif8w1p.cloudfront.net/megascans/' + path || '';
};
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return 'https://cdn.quixel.com/quixel/thumbs/' + path;
};

var para = (0, _glamor.css)(_fonts.p3, {
  color: _css.colors.gray
});

var jobContainer = (0, _glamor.css)({
  display: 'flex',
  justifyContent: 'center'
});

var jobSubContainer = (0, _glamor.css)({
  display: 'flex',
  justifyContent: 'space-between',
  borderBottom: '2px solid #222',
  alignItems: 'center',
  textAlign: 'left',
  paddingTop: '1.625rem',
  paddingBottom: '1.625rem'
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  maxWidth: 960
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  maxWidth: 960
}), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  minWidth: 700
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  minWidth: 650
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  minWidth: 450
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  minWidth: 350
}), (0, _css.maxWidth)(_css.breakpoints.small)({
  minWidth: 271
}));

var containerSection = (0, _glamor.css)({
  flexBasis: '50%'
});

var containerSectionL = (0, _glamor.css)({
  flexBasis: '70%'
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexBasis: '60%'
}));

var containerSectionR = (0, _glamor.css)({
  flexBasis: '30%'
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexBasis: '40%'
}));

var headingRow = (0, _glamor.css)({
  marginTop: '3rem'
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  marginTop: '6rem'
}));

var label = (0, _glamor.css)(_fonts.subH2, {
  letterSpacing: 'unset',
  textTransform: 'uppercase'
});

var S3_URL = 'https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/';
var PLUGINS_VERSION = 'plugins_6';
var PLATFORM = 'win';

var getPluginURL = function getPluginURL(plugin, version) {
  return '' + S3_URL + PLUGINS_VERSION + '/' + plugin + '/' + PLATFORM + '/' + version + '.zip';
};
var groupedPlugins = {
  blender: {
    title: "Blender",
    platforms: ['win', 'mac', 'linux'],
    help: "https://docs.google.com/document/d/1X4HDDtZJL_rGU639KIr5-P_9EZWkpCu1Ul3yPJAqi_I/",
    versions: [{
      version: "3.2",
      community: "https://help.quixel.com/hc/en-us/community/posts/360012517557-Megascans-Plugin-for-Blender-v3-1-1-What-s-new",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_10/blender/win/3.2.zip"
    }, {
      version: "3.0",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000088878-Blender",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_9/blender/win/3.0.zip"
    }, {
      version: "2.0",
      community: "https://help.quixel.com/hc/en-us/community/posts/360006967458-LiveLink-update-Blender-LiveLink-v2-0-",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/blender/win/2.0.zip"
    }, {
      version: "1.3",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000088878-Blender",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/blender/win/1.3.zip"
    }, {
      version: "1.2",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000088878-Blender",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/blender/win/1.2.zip"
    }]
  },
  cinema4d: {
    title: "Cinema 4D",
    platforms: ['win', 'mac'],
    help: "https://docs.google.com/document/d/1rUcaQVRd38LGhr6GLeyuwHTxLx91B0LlN4mgGO3wjMI/edit?usp=sharing",
    versions: [{
      version: "1.12",
      community: "https://help.quixel.com/hc/en-us/community/posts/360009276737-Megascans-Plugin-for-Cinema-4D-v1-12-What-s-new",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_9/cinema4d/win/1.12.zip"
    }, {
      version: "1.6",
      community: "https://help.quixel.com/hc/en-us/community/posts/360005475658-Quixel-Bridge-Cinema-4D-LiveLink-Documentation-Features-and-Updates",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/cinema4d/win/1.6.zip"
    }, {
      version: "1.5",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000090397-Cinema-4D",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/cinema4d/win/1.5.zip"
    }]
  },
  clarisse: {
    title: "Clarisse",
    platforms: ['win', 'mac', 'linux'],
    help: "https://docs.google.com/document/d/1rI9XOGvuc3k5_bO6_ZVDCVVzHDppFjSXhEFjESo40cQ/edit?usp=sharing",
    versions: [{
      version: "1.4",
      community: "https://help.quixel.com/hc/en-us/community/posts/360009584778-Megascans-Plugin-for-Clarisse-v1-4-What-s-new",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_9/clarisse/win/1.4.zip"
    }, {
      version: "1.1",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000161258-Clarisse",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/clarisse/win/1.1.zip"
    }, {
      version: "1.0",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000161258-Clarisse",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/clarisse/win/1.0.zip"
    }]
  },
  houdini: {
    title: "Houdini",
    platforms: ['win', 'mac', 'linux'],
    help: "https://docs.google.com/document/d/1UfU-6zVLrmrzbcPRW9OJdoXgQHRs-1NaYwiyGy9Ui90/edit?usp=sharing",
    versions: [{
      version: "4.4",
      community: "https://help.quixel.com/hc/en-us/community/posts/360010987677-Megascans-Plugin-for-SideFX-Houdini-v4-4-What-s-new",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_10/houdini/win/4.4.zip"
    }, {
      version: "3.4.0",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000090417-Houdini",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/houdini/win/3.4.0.zip"
    }, {
      version: "3.1",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000090417-Houdini",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/houdini/win/3.1.zip"
    }, {
      version: "3.0",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000090417-Houdini",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/houdini/win/3.0.zip"
    }]
  },
  marmoset: {
    title: "Marmoset Toolbag",
    platforms: ['win', 'mac'],
    help: "https://docs.google.com/document/d/1NLsJIcWdiEJbiEbFCL9-eUz-T23sooIomSAoJCfBnTs/edit?usp=sharing",
    versions: [{
      version: "3.4",
      community: "https://help.quixel.com/hc/en-us/community/posts/360012700658-Megascans-Plugin-for-Marmoset-TB3-v3-2-2-What-s-new",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_10/marmoset/win/3.4.zip"
    }, {
      version: "3.1",
      community: "https://help.quixel.com/hc/en-us/community/posts/360005477938-Quixel-Bridge-Marmoset-Toolbag-LiveLink-Documentation-Features-and-Updates",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/marmoset/win/3.1.zip"
    }]
  },
  max: {
    title: "3ds Max",
    platforms: ['win'],
    help: "https://docs.google.com/document/d/14hRoUL0zr7PJOEWbjH2EHoVg1KAVlT5k7aHim9UYU1g/edit?usp=sharing",
    versions: [{
      version: "4.13",
      community: "https://help.quixel.com/hc/en-us/community/posts/360012700698-Megascans-Plugin-for-3ds-Max-v4-12-2-What-s-new",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_10/max/win/4.13.zip"
    }, {
      version: "4.12",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000088898-3ds-Max",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_9/max/win/4.12.zip"
    }, {
      version: "4.5",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000088898-3ds-Max",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/max/win/4.5.zip"
    }, {
      version: "4.3",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000088898-3ds-Max",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/max/win/4.3.zip"
    }, {
      version: "4.0",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000088898-3ds-Max",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/max/win/4.0.zip"
    }]
  },
  maya: {
    title: "Maya",
    platforms: ['win', 'mac', 'linux'],
    help: "https://docs.google.com/document/d/1b85P3MkyTDMm-K966pM9WvqQMbucqim0puunds9xo-g/edit?usp=sharing",
    versions: [{
      version: "4.9",
      community: "https://help.quixel.com/hc/en-us/community/posts/360012517377-Megascans-Plugin-for-Autodesk-Maya-v4-8-3-What-s-new",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_10/maya/win/4.9.zip"
    }, {
      version: "4.8",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000088918-Maya",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_9/maya/win/4.8.zip"
    }, {
      version: "4.0",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000088918-Maya",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/maya/win/4.0.zip"
    }]
  },
  unity: {
    title: "Unity",
    platforms: ['win', 'mac'],
    help: "https://docs.google.com/document/d/1cu1ysjZx62O_MoYaXvBI70WjqHTEGpoRYYcfUmRfykc/edit?usp=sharing",
    versions: [{
      version: "3.11",
      community: "https://help.quixel.com/hc/en-us/community/posts/360009696057-Megascans-Plugin-for-Unity-v3-11-What-s-new",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_10/unity/win/3.11.zip"
    }, {
      version: "3.7",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000090297-Unity",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_9/unity/win/3.7.zip"
    }, {
      version: "3.6",
      community: "https://help.quixel.com/hc/en-us/community/posts/360005336338-Quixel-Bridge-Unity-Livelink-Documentation-Features-and-Updates",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_6/unity/win/3.6.zip"
    }]
  },
  unreal: {
    title: "UE4",
    platforms: ['win', 'mac', 'linux'],
    help: "https://www.notion.so/quixel/Installation-e9ac54f81ff24484988bba093d612f6a",
    versions: [{
      version: "6.2",
      community: "https://help.quixel.com/hc/en-us/community/posts/360012700638-Megascans-Plugin-for-Unreal-Engine-v6-1-2-What-s-new",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_10/unreal/win/6.2.zip"
    }, {
      version: "5.3",
      community: "https://help.quixel.com/hc/en-us/community/topics/360000090277-UE4",
      url: "https://quixel-megascans-static.s3-us-west-2.amazonaws.com/bridge/plugins_9/unreal/win/5.3.zip"
    }]
  }
};

var PluginRow = function PluginRow(props) {
  return _react2.default.createElement(
    'div',
    { className: jobSubContainer },
    _react2.default.createElement(
      'div',
      { className: containerSectionL },
      _react2.default.createElement(_TextButton2.default, { className: (0, _glamor.css)({ padding: 0, fontWeight: '400', fontSize: '18px', textTransform: 'none' }), href: props.url, newWindow: true, label: 'Plugin v' + props.version })
    ),
    _react2.default.createElement(
      'div',
      { className: containerSectionR },
      _react2.default.createElement(_TextButton2.default, { className: (0, _glamor.css)(para, { textTransform: 'none' }), href: props.community, newWindow: true, label: 'Change log' })
    )
  );
};

var PluginSection = function PluginSection(_ref) {
  var index = _ref.index,
      plugins = _ref.plugins;
  return _react2.default.createElement(
    'div',
    { className: (0, _glamor.css)(jobContainer) },
    _react2.default.createElement(
      'div',
      { className: containerSection },
      _react2.default.createElement(
        'div',
        { className: (0, _glamor.css)(jobSubContainer, index !== 0 && headingRow) },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: label },
            '' + plugins.title
          ),
          _react2.default.createElement(
            'span',
            { className: (0, _glamor.css)(label, { fontWeight: 500, color: _css.colors.gray, padding: '0 12px' }) },
            ' | '
          ),
          _react2.default.createElement(
            'span',
            { className: (0, _glamor.css)(label, { fontWeight: 500, color: _css.colors.gray, textTransform: 'uppercase', paddingRight: 15 }) },
            '' + plugins.platforms.join(' \xB7 ')
          ),
          _react2.default.createElement(
            'span',
            { className: (0, _glamor.css)({ display: 'inline-block', verticalAlign: 'text-bottom' }) },
            _react2.default.createElement(
              'a',
              { className: (0, _glamor.css)(para, { display: 'inline-block', lineHeight: '1.2', transition: 'all 0.2s', textTransform: 'none', textDecoration: 'none' }, { fontSize: '0.9rem', padding: '0px 6px', fontWeight: 700, cursor: 'pointer', borderRadius: '50%', border: '2px solid ' + _css.colors.gray, color: _css.colors.gray, ':hover': { color: _css.colors.white, border: '2px solid ' + _css.colors.white } }), href: plugins.help, target: '_blank' },
              '?'
            )
          )
        )
      ),
      plugins.versions.map(function (plugin) {
        return _react2.default.createElement(PluginRow, plugin);
      })
    )
  );
};

var Plugins = function (_React$Component) {
  (0, _inherits3.default)(Plugins, _React$Component);

  function Plugins() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Plugins);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Plugins.__proto__ || (0, _getPrototypeOf2.default)(Plugins)).call.apply(_ref2, [this].concat(args))), _this), _this.renderHeader = function () {
      return _react2.default.createElement(_Hero2.default, {
        bg: cloudFrontUtils.cf_qx_page('archviz', 'bridge-hero.jpg'),
        superIconUrls: [cf('home/quixel_2080_logo.png')],
        primaryLabel: '',
        primaryTo: '',
        title: 'ONE-CLICK INTEGRATIONS',
        subTitle: 'Easily manage your 3D & 2D assets and send to any DCC, engine or renderer',
        secondaryLabel: '',
        secondaryTo: ''
      });
    }, _this.renderContent = function () {
      return _react2.default.createElement(_Section2.default, {
        innerClassName: (0, _glamor.css)({ marginBottom: '4.5rem' }),
        subHeading: '',
        title: 'BRIDGE PLUGINS',
        headingBeforeBreak: 'We hire creative, passionate people,',
        headingAfterBreak: 'and give them the autonomy to do great work.',
        content: _this.renderPlugins()
      });
    }, _this.renderPlugins = function () {
      return (0, _keys2.default)(groupedPlugins).map(function (key, index) {
        return _react2.default.createElement(PluginSection, { index: index, plugins: groupedPlugins[key] });
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Plugins, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        { documentTitle: ' - Plugins', documentImage: cloudfrontThumbs('page-thumb-jobs.jpg'), documentDescription: 'Easily manage your 3D & 2D assets and send to any DCC, engine or renderer.' },
        _react2.default.createElement(
          'div',
          null,
          this.renderHeader(),
          this.renderContent()
        )
      );
    }
  }]);
  return Plugins;
}(_react2.default.Component);

exports.default = Plugins;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Plugins/Plugins.jsx
// module id = 2619
// module chunks = 0